// Logic
import { User } from '@weblite/ts-action/user'
// Common
import { ProfileInfoItem } from '$common/profile-info-item'
import { showPhoneMenu } from '$comp/modals/menus/phone-menu'
import { showCopyMenu } from '$comp/modals/menus/copy-menu'
import {
  showBioSavedInMemorySnackbar,
  showUsernameSavedInMemorySnackbar,
} from '$comp/snackbars'
import { ProfileInfoParser } from '$common/profile-info-parser'
// Localization
import { t } from '$i18n'

interface Prop {
  user: User
}

export function UserProfileInfo({ user }: Prop) {
  const { phone, username, bio } = user

  if (!(username || bio || phone)) return null
  return (
    <>
      {phone && (
        <ProfileInfoItem
          value={phone}
          label={t('user.phone')}
          onClick={() => showPhoneMenu({ phone })}
        />
      )}

      {bio && (
        <ProfileInfoParser
          value={bio}
          label={t('user.bio')}
          onClick={() =>
            showCopyMenu({
              text: bio,
              onDone: showBioSavedInMemorySnackbar,
            })
          }
        />
      )}

      {username && (
        <ProfileInfoItem
          value={`@${username}`}
          label={t('user.username')}
          onClick={() =>
            showCopyMenu({
              text: username,
              onDone: showUsernameSavedInMemorySnackbar,
            })
          }
        />
      )}
    </>
  )
}
